import { Flex, Text, Button } from '@chakra-ui/react';
import { ShowSkipStop } from '../../components/ShowSkipStop';

export const AIMessageUnreviewed = ({
  restartDetails = {},
  onStopOpen,
  openCandidateSlider = () => {},
}) => {
  return (
    <Flex flexDir="column" gap="12px" data-test-id="flow-restart-popover-ai">
      <Text fontWeight="semiBold" fontSize="24px">
        AI Messages - Pending Review
      </Text>
      <Text type="muted" color="#16161680">
        AI message for this candidate is not reviewed. Resume the flow by
        reviewing the AI-generated message
      </Text>
      <Button
        onClick={openCandidateSlider}
        data-test-id="flow-restart-action-ai-cta"
      >
        Review Now
      </Button>
      <ShowSkipStop restartDetails={restartDetails} onStopOpen={onStopOpen} />
    </Flex>
  );
};
